export const stats = [
  { value: '8', label: 'Volumi Completi' },
  { value: '500+', label: 'Pagine di Risorse' },
  { value: '100', label: 'Attività Extra (Bonus 4)' },
  { value: '100%', label: "Pronto per l'Aula" },
]

export const beforeItems = [
  'Passare le domeniche a cercare disperatamente idee su Pinterest.',
  'Fotocopie vecchie e sgranate che non stimolano nessuno.',
  'Ansia da «ultimo minuto» prima di entrare in classe.',
  'Burocrazia infinita e griglie di valutazione create da zero a mezzanotte.',
  'Sentirsi «quella del disegnino» agli occhi dei genitori.',
]

export const afterItems = [
  'Un intero anno mappato mese per mese, dalla 1ª Primaria alla 3ª Media.',
  'Lezioni visuali ad alto impatto pronte per la tua LIM.',
  'Un percorso logico e professionale che cresce con i tuoi studenti.',
  'Valutazione rapida: voti pronti in 5 minuti con criteri oggettivi.',
  'Più tempo per te, più rispetto per la tua materia e più gioia in classe.',
]

export type Volume = {
  grade: string
  title: string
  text: string
}

export const primaryVolumes: Volume[] = [
  {
    grade: 'Classe 1ª',
    title: 'Il Risveglio Creativo',
    text: 'Colori primari, segni e scoperta sensoriale.',
  },
  {
    grade: 'Classe 2ª',
    title: 'Texture e Profondità',
    text: 'I grandi maestri e la magia della tridimensionalità.',
  },
  {
    grade: 'Classe 3ª',
    title: 'Viaggio nel Tempo',
    text: 'Dalla Preistoria al mondo antico con laboratori pratici.',
  },
  {
    grade: 'Classe 4ª',
    title: 'La Tecnica Prende Forma',
    text: 'Luci, ombre e introduzione alla prospettiva.',
  },
  {
    grade: 'Classe 5ª',
    title: 'Verso il Moderno',
    text: 'Le avanguardie e il passaggio alla secondaria.',
  },
]

export const secondaryVolumes: Volume[] = [
  {
    grade: '1ª Media',
    title: 'Linguaggio Visivo',
    text: "Composizione, geometria dell'arte e Impressionismo.",
  },
  {
    grade: '2ª Media',
    title: 'Rinascimento e Barocco',
    text: "Il cuore dell'arte italiana con schede tecniche avanzate.",
  },
  {
    grade: '3ª Media',
    title: 'Il Novecento e Oltre',
    text: "Dal Cubismo alla Street Art, pronti per l'esame finale.",
  },
]

export const bonuses = [
  {
    title: 'Registro Voti & Valutazione Rapida',
    value: '€17',
    text: "Il sistema definitivo per valutare l'Arte in 5 minuti. Griglie professionali e rubriche pronte per giustificare ogni voto con criteri oggettivi davanti a colleghi e genitori.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/0e421886-ca83-4c83-9df9-6c261d1e7b41.jpg',
  },
  {
    title: 'Kit Inclusione — DSA, BES e DVA',
    value: '€14',
    text: 'Arte per Tutti: strategie pratiche per una classe realmente inclusiva. Materiali adattati per non lasciare indietro nessuno senza dover rifare il lavoro da zero.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4288a5d6-fde0-4421-aa12-31e486a468b0.jpg',
  },
  {
    title: 'Manuale della LIM & Didattica Digitale',
    value: '€9',
    text: "L'Arte Interattiva: trasforma la tua classe in un museo digitale. Impara a usare la LIM per rendere l'arte un'esperienza immersiva e moderna.",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/72ad12a0-bddd-4ccf-81ff-1ccb618f3caa.jpg',
  },
  {
    title: 'Banca del Tempo — 100 Attività da 10 Minuti',
    value: '€17',
    text: 'Mai più senza idee: il kit di sopravvivenza per ogni occasione. Attività veloci, creative e coinvolgenti per coprire ogni buco o fine lezione.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d84dd465-98d3-4505-95ce-7d8597c10e75.jpg',
  },
  {
    title: 'Kit "Profe-Genitori" Sereno',
    value: '€19',
    text: 'Comunicazione Efficace: come valorizzare il tuo lavoro. Smetti di essere sottovalutata e impara a far capire il peso educativo della tua materia alle famiglie.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/f4a580d6-8ba4-4c3f-8667-b4e5d7cba901.jpg',
  },
]

export const offerRows = [
  { label: 'Pack Arte Pronta (8 Volumi)', value: '€197' },
  { label: '5 Bonus Strategici', value: '€76' },
]

export const testimonials = [
  {
    quote:
      'La programmazione annuale già fatta mi ha salvato il mese di settembre. Finalmente i bambini seguono le lezioni sulla LIM senza annoiarsi.',
    name: 'Chiara L.',
    role: 'Insegnante Scuola Primaria',
  },
  {
    quote:
      'Materiale di una qualità che non si trova in Italia. Il kit sulla valutazione mi ha tolto un peso enorme con i genitori.',
    name: 'Stefano M.',
    role: 'Docente di Arte, Scuola Media',
  },
]

export const faqs = [
  {
    q: 'In che formato sono i materiali?',
    a: 'Sono PDF ad alta risoluzione pronti da stampare o proiettare sulla LIM.',
  },
  {
    q: 'È adatto a chi non è specialista di arte?',
    a: 'Sì, ogni lezione guida il docente passo dopo passo, con obiettivi e materiali già indicati.',
  },
  {
    q: 'Come ricevo il materiale?',
    a: 'Immediatamente dopo il pagamento via email.',
  },
  {
    q: 'Posso usarlo su tablet?',
    a: 'Sì, i file sono compatibili con qualsiasi dispositivo digitale.',
  },
]

export const heroGuarantees = [
  'Download digitale istantaneo',
  'PDF pronti per la stampa',
  'Pagamento unico',
]

export const footerLinks = ['Termini e Condizioni', 'Privacy Policy', 'Contatti']
